import axios from 'axios';

class NotificationService {
  // Send notification to specific users
  static async sendToUsers(data) {
    try {
      const response = await axios.post('/notifications/admin/send-to-users', data);
      return { success: true, data: response.data };
    } catch (error) {
      return { 
        success: false, 
        error: error.response?.data?.message || 'Failed to send notification',
        details: error.response?.data?.errors || []
      };
    }
  }

  // Send notification to all users
  static async sendToAll(data) {
    try {
      const response = await axios.post('/notifications/admin/send-to-all', data);
      return { success: true, data: response.data };
    } catch (error) {
      return { 
        success: false, 
        error: error.response?.data?.message || 'Failed to send notification',
        details: error.response?.data?.errors || []
      };
    }
  }

  // Get notification history
  static async getHistory(params = {}) {
    try {
      const queryString = new URLSearchParams(params).toString();
      const response = await axios.get(`/notifications/admin/history?${queryString}`);
      return { success: true, data: response.data };
    } catch (error) {
      return { 
        success: false, 
        error: error.response?.data?.message || 'Failed to fetch notification history' 
      };
    }
  }

  // Get notification details
  static async getNotificationDetails(id) {
    try {
      const response = await axios.get(`/notifications/admin/history/${id}`);
      return { success: true, data: response.data };
    } catch (error) {
      return { 
        success: false, 
        error: error.response?.data?.message || 'Failed to fetch notification details' 
      };
    }
  }

  // Cancel scheduled notification
  static async cancelNotification(id) {
    try {
      const response = await axios.post(`/notifications/admin/cancel/${id}`);
      return { success: true, data: response.data };
    } catch (error) {
      return { 
        success: false, 
        error: error.response?.data?.message || 'Failed to cancel notification' 
      };
    }
  }

  // Search users
  static async searchUsers(params = {}) {
    try {
      const queryString = new URLSearchParams(params).toString();
      const response = await axios.get(`/notifications/admin/search-users?${queryString}`);
      return { success: true, data: response.data };
    } catch (error) {
      return { 
        success: false, 
        error: error.response?.data?.message || 'Failed to search users' 
      };
    }
  }

  // Get notification templates
  static async getTemplates() {
    try {
      const response = await axios.get('/notifications/admin/templates');
      return { success: true, data: response.data };
    } catch (error) {
      return { 
        success: false, 
        error: error.response?.data?.message || 'Failed to fetch templates' 
      };
    }
  }

  // Get dashboard statistics
  static async getDashboardStats() {
    try {
      const response = await axios.get('/notifications/admin/dashboard-stats');
      return { success: true, data: response.data };
    } catch (error) {
      return { 
        success: false, 
        error: error.response?.data?.message || 'Failed to fetch dashboard stats' 
      };
    }
  }

  // Get scheduler status
  static async getSchedulerStatus() {
    try {
      const response = await axios.get('/notifications/admin/scheduler-status');
      return { success: true, data: response.data };
    } catch (error) {
      return { 
        success: false, 
        error: error.response?.data?.message || 'Failed to fetch scheduler status' 
      };
    }
  }

  // Trigger scheduler manually
  static async triggerScheduler() {
    try {
      const response = await axios.post('/notifications/admin/trigger-scheduler');
      return { success: true, data: response.data };
    } catch (error) {
      return { 
        success: false, 
        error: error.response?.data?.message || 'Failed to trigger scheduler' 
      };
    }
  }

  // Bulk cancel notifications
  static async bulkCancel(notificationIds) {
    try {
      const response = await axios.post('/notifications/admin/bulk-cancel', { notificationIds });
      return { success: true, data: response.data };
    } catch (error) {
      return { 
        success: false, 
        error: error.response?.data?.message || 'Failed to cancel notifications' 
      };
    }
  }

  // Resend failed notification
  static async resendNotification(id) {
    try {
      const response = await axios.post(`/notifications/admin/resend/${id}`);
      return { success: true, data: response.data };
    } catch (error) {
      return { 
        success: false, 
        error: error.response?.data?.message || 'Failed to resend notification' 
      };
    }
  }

  // Get existing notification stats (from current API)
  static async getNotificationStats() {
    try {
      const response = await axios.get('/notifications/stats');
      return { success: true, data: response.data };
    } catch (error) {
      return { 
        success: false, 
        error: error.response?.data?.message || 'Failed to fetch notification stats' 
      };
    }
  }
}

export default NotificationService;
